export default __webpack_public_path__ + "static/logo-10-3b46cabc1eeae5820719bb02d0b8a6ba.png";